import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';
import { useDispatch } from 'react-redux';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';

import { AppDispatch } from 'redux/store';
import { forgotPassword } from 'redux/slices/auth/authSlice';
import Routes from 'constants/routes';
import { FloatingField } from 'components';
import AuthLayaout from 'pages/Auth/AuthLayout';
import { notify } from 'components/Common/Toast';
import CustomButton from 'components/Common/Button';

import './Auth.css';

const formSchema = yup
    .object({
        username: yup.string().required('Username is required').lowercase().trim(),
    })
    .required();

export interface ForgotPasswordFormInputs {
    username: string;
}

export default function ForgotPassword() {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<ForgotPasswordFormInputs>({
        resolver: yupResolver(formSchema),
        defaultValues: {
            username: '',
        },
    });

    const submit = async (data: { [x: string]: any }) => {
        const { username } = data || {};
        setIsLoading(true);
        try {
            const res = await dispatch(forgotPassword(username));
            const { contextResponse } = res?.payload || {};
            if (contextResponse?.statusCode) {
                notify('Email sent to your mail address with a temporary password, Please login.', 'success');
                navigate(Routes.auth.login);
            }
        } catch (error: any) {
            notify(error.message, 'error');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <AuthLayaout showBackButton>
            <div className="Auth-form">
                <p className="Auth-form-title">Forgot Password?</p>
                <p className="Auth-form-subtitle">
                    Not to worry! Enter username associated with your account and we’ll send you a temporary password.
                </p>
                <Stack gap={2}>
                    <Controller
                        name="username"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                            <FloatingField label="Username" value={value} onChange={onChange} error={errors.username?.message} />
                        )}
                    />
                    <CustomButton loading={isLoading} title="SUBMIT" onClick={handleSubmit(submit)} />
                </Stack>
            </div>
        </AuthLayaout>
    );
}
